<div class="vh-100 m-3">
    <div>
        <h1> Amarant Dashboard</h1>
    </div>
</div>